import { defineStore } from "pinia";

let dismissTimer = null;
let undoHandler = null;

export const useUndoToastStore = defineStore("undoToast", {
  state: () => ({
    id: 0,
    visible: false,
    message: "",
    tone: "success",
    duration: 6000,
    undoing: false,
    canUndo: false,
    undoMessage: "Action undone.",
  }),

  actions: {
    show({
      message,
      onUndo = null,
      undoMessage = "Action undone.",
      tone = "success",
      duration = 6000,
    }) {
      window.clearTimeout(dismissTimer);
      undoHandler = typeof onUndo === "function" ? onUndo : null;
      this.id += 1;
      this.visible = true;
      this.message = message;
      this.tone = tone;
      this.duration = duration;
      this.undoing = false;
      this.canUndo = Boolean(undoHandler);
      this.undoMessage = undoMessage;

      const toastId = this.id;
      dismissTimer = window.setTimeout(() => {
        if (this.id === toastId) {
          this.dismiss();
        }
      }, duration);
    },

    dismiss() {
      window.clearTimeout(dismissTimer);
      dismissTimer = null;
      undoHandler = null;
      this.visible = false;
      this.canUndo = false;
      this.undoing = false;
    },

    async undo() {
      if (!undoHandler || this.undoing) {
        return;
      }

      window.clearTimeout(dismissTimer);
      const handler = undoHandler;
      const successMessage = this.undoMessage;
      undoHandler = null;
      this.canUndo = false;
      this.undoing = true;

      try {
        await handler();
        this.show({
          message: successMessage,
          duration: 3000,
        });
      } catch (error) {
        this.show({
          message:
            error?.response?.data?.message || "Unable to undo that action.",
          tone: "error",
          duration: 6000,
        });
      }
    },
  },
});
